// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"211":"works","235":"worksInfo","522":"aboutUs","999":"timeAxis"}[chunkId] + "." + {"211":"bbf10e28","235":"9f672aca","522":"c370fc12","999":"932bfeb3"}[chunkId] + ".js";
};